import { render, staticRenderFns } from "./ForgetPasswordComp.vue?vue&type=template&id=4a400edb"
import script from "./ForgetPasswordComp.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordComp.vue?vue&type=script&lang=js"
import style0 from "./ForgetPasswordComp.vue?vue&type=style&index=0&id=4a400edb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports